"use client"

import Image from "next/image"
import Link from "next/link"

import {
    NavigationMenu,
    NavigationMenuContent,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger,
} from "@/components/ui/navigation-menu"
import { useApi } from "@/src/api/useApi"
import { ConvertLink } from "@/src/tools"
import BasketHeader from "./components/BasketHeader"
import InputSearch from "./components/InputSearch"
import MenuHeader from "./components/MenuHeader"
import ProfileHeader from "./components/ProfileHeader"
import SearchHeader from "./components/SearchHeader"

export default function HeaderScreen() {
    const { data } = useApi<any>("/category-get")

    return (
        <header className="bg-white dark:bg-slate-800 shadow-md border-b-4 border-[#223843]">
            <div className="container mx-auto max-w-7xl px-4 py-3">
                <div className="flex items-center justify-between">
                    {/* Mobile: menu + logo */}
                    <div className="sm:hidden flex items-center ">
                        <MenuHeader cat={data} />
                        <Link href="/" className="ml-2">
                            <Image
                                alt="logo hiroonia"
                                src="/hiroonia.png"
                                height={48}
                                width={48}
                                style={{ objectFit: "contain" }}
                                className="!w-12 !h-12"
                                priority
                            />
                        </Link>
                    </div>
                    {/* Desktop: logo + nav */}
                    <div className="max-sm:hidden flex items-center justify-between w-full">
                        {/* لوگو */}
                        <div className="flex">
                            <Link href="/" className="flex-shrink-0 flex items-center">
                                <Image
                                    alt="logo hiroonia"
                                    src="/hiroonia.png"
                                    height={48}
                                    width={48}
                                    style={{ objectFit: "contain" }}
                                    className="!w-12 !h-12"
                                    priority
                                />
                            </Link>
                            {/* navigation */}
                            <NavigationMenu>
                                <NavigationMenuList className="rtl" style={{ direction: "rtl" }}>
                                    {/* دسته‌بندی‌ها - باید اولین آیتم باشد */}
                                    <NavigationMenuItem>
                                        <NavigationMenuTrigger
                                            className="
          font-bold px-4 py-2 text-red-600
          focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500
          transition-colors
        "
                                        >
                                            دسته‌بندی‌ها
                                        </NavigationMenuTrigger>
                                        <NavigationMenuContent>
                                            <ul className="grid gap-2 w-[380px] sm:w-[460px] md:grid-cols-3 p-4 text-right">
                                                {data?.data?.map((cat: any) => (
                                                    <li key={cat.cat_title}>
                                                        <NavigationMenuLink asChild>
                                                            <Link
                                                                href={`/categories/${ConvertLink(cat.cat_url)}`}
                                                                className="
                    px-3 font-bold
                    flex items-center justify-end
                    whitespace-nowrap overflow-hidden text-ellipsis
                    rounded-lg border border-slate-100 dark:border-slate-700
                    bg-white dark:bg-slate-800
                    py-2
                    hover:bg-red-50 dark:hover:bg-red-900
                    transition text-base min-h-[42px]
                  "
                                                                style={{ maxWidth: 140 }}
                                                                title={cat.cat_title}
                                                            >
                                                                {cat.cat_title}
                                                            </Link>
                                                        </NavigationMenuLink>
                                                    </li>
                                                ))}
                                            </ul>
                                        </NavigationMenuContent>
                                    </NavigationMenuItem>
                                    {/* دیگر لینک‌ها */}
                                    <NavigationMenuItem>
                                        <NavigationMenuLink asChild>
                                            <Link href="/mag" className="px-3 font-bold">مقالات</Link>
                                        </NavigationMenuLink>
                                    </NavigationMenuItem>
                                    <NavigationMenuItem>
                                        <NavigationMenuLink asChild>
                                            <Link href="/brand" className="px-3 font-bold">برند ها</Link>
                                        </NavigationMenuLink>
                                    </NavigationMenuItem>
                                    <NavigationMenuItem>
                                        <NavigationMenuLink asChild>
                                            <Link href="/contact" className="px-3 font-bold">تماس با ما</Link>
                                        </NavigationMenuLink>
                                    </NavigationMenuItem>
                                    <NavigationMenuItem>
                                        <NavigationMenuLink asChild>
                                            <Link href="/about" className="px-3 font-bold">درباره ما</Link>
                                        </NavigationMenuLink>
                                    </NavigationMenuItem>
                                </NavigationMenuList>
                            </NavigationMenu>
                        </div>



                    </div>
                    <div className="sm:hidden block">
                        <InputSearch />
                    </div>

                    <div className="flex items-center">
                        <div className="items-center">
                            <ProfileHeader />
                        </div>
                        <div className="hidden sm:block">
                            <SearchHeader />
                        </div>
                        <BasketHeader />
                    </div>

                </div>

            </div>
        </header>
    )
}
